import React, { useEffect, useState } from "react";
import { Button } from 'react-bootstrap';
import {Link, useParams} from 'react-router-dom';
import styled from 'styled-components';
import {getForIndividualsStep} from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";
const id = 1;

export default function ViewSteps() {
    const { partnerId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data,setStep] = useState({
    step1:"",
    step2:"",
    step3:"",
    step4:"",
    index: null,
  });
  useEffect(() => {
    const fetchSteps = async () => {
      setIsLoading(true);
      if (!Number(id)) {
        setIsLoading(false);
        return;
      }

      try {
        const res = await getForIndividualsStep();
        const stepData = res.data.data[0];
        setStep({ ...stepData, index: res.data.data.indexOf(stepData) });             
        console.log(stepData);                     
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSteps();
  }, []);

  const columns = ["Step Number", "Content"];
  const rows = [];
  
  for (let i = 1; i <= 4; i++) {
    const step = data[`step${i}`];
    if (step) {
      rows.push([`Step ${String(i).padStart(2, '0')}`, step]);
    }
  }
    return(
     <>
      {isLoading ? <CmsCircularProgress/> : 
        <ContentWrapper>
            <HomeTitle>Step Cards Section</HomeTitle>
            <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
            <ButtonWrapper>
                <Link to={`/${partnerId}/forindividuals`}>
                    <Button variant="secondary">Go Back</Button>
                </Link>
                
                <Link to={`/${partnerId}/forindividuals/step/edit/${id}`}>
                    <Button>Edit steps section</Button>
                </Link>
            </ButtonWrapper>
        </ContentWrapper> }
     </>
    );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const TableWrapper = styled.div`
 margin: 0 auto;
  overflow-x: auto;
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 10px;
  border: 2px solid #ccc;
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border: 1px solid #ddd; 
`;

const ButtonWrapper = styled.div`
    margin: 0 auto;
    padding-top: 40px;
    display: flex;
    gap: 5rem;
    justify-content: center;
     @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
